import React from "react";
import {
  Alert,
  Form,
  Badge,
  Table,
  Button,
  Row,
  Col,
  Checkbox,
  Input,
} from "antd";
import get from "lodash/get";
import map from "lodash/map";
import find from "lodash/find";
import moment from "moment-timezone";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import { withRouter } from "react-router";

import { delegationLogSignRequest } from "../../api/requests";

import {
  getDelegationLogSignPermission,
  getUserShortTimezone,
  getUserTimezone,
} from "../../reducers/user/selectors";

import { logout } from "../../reducers/user/actions";
import classes from "./DelegationLogs.css";
import Signature from "../FormBuilder/Signature/Signature";
import { withParams } from "../../utils/url";

const routes = require("../../routes.json");

class DelegationLogSignForm extends React.Component {
  constructor(props) {
    super(props);

    const params = new URLSearchParams(window.location.search);

    this.state = {
      isLoading: false,
      requestResult: {},
      step: 1,
      type: params.get("type"),
    };
  }

  handleSubmit = async (e) => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        try {
          await delegationLogSignRequest(this.props.id, this.state.type, {
            password: values.password,
            confirm: values.confirm,
            signature: values.signature,
            initials: values.initials,
          });

          this.setState({
            isLoading: false,
            requestResult: {
              type: "success",
              message: this.props.i18n.t("Success"),
            },
          });

          setTimeout(() => {
            this.props.history.push(routes.admin.delegationLogsSigning);
            window.location.reload();
          }, 1500);
        } catch (e) {
          if (get(e, "response.status") === 401) {
            this.props.logout();
            return;
          }
          this.setState({
            isLoading: false,
            requestResult: {
              type: "error",
              message: get(e, "response.data.message", "Error"),
            },
          });

          if (get(e, "response.data.errors")) {
            const errors = {};
            Object.keys(get(e, "response.data.errors")).forEach(
              (errorFieldKey) => {
                errors[errorFieldKey] = {
                  value: values[errorFieldKey],
                  errors: get(e, `response.data.errors.${errorFieldKey}`).map(
                    (errorMessage) => new Error(errorMessage)
                  ),
                };
              }
            );
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  render() {
    const { isLoading, requestResult, step, type } = this.state;
    const { getFieldDecorator } = this.props.form;
    const { delegationLogSignPermission, delegationLog, sites } = this.props;

    const site = find(sites, ({ id }) => id === delegationLog.site_id);

    const isEditable = delegationLogSignPermission;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <div style={{ textAlign: "center" }}>
            {type === "staff_signature" && (
              <div>
                <h3 className="headline">{this.props.i18n.t("NamespaceDelegationLogs:Staff member signature")}</h3>
                <h4 className="headline">
                  {this.props.i18n.t("NamespaceDelegationLogs:Study Personnel Signature and Delegation Log")}
                </h4>
                <br />
              </div>
            )}
            {type === "qi_start_of_delegation_signature" && (
              <div>
                <h3 className="headline">{this.props.i18n.t("NamespaceDelegationLogs:QI start of delegation signature")}</h3>
                <h4 className="headline">
                  {this.props.i18n.t("NamespaceDelegationLogs:Study Personnel Signature and Delegation Log")}
                </h4>
                <h5 className="headline">
                  {this.props.i18n.t("NamespaceDelegationLogs:My signature confirms that information on the Delegation Log is accurate")}
                </h5>
                <br />
              </div>
            )}
            {type === "qi_staff_confirmed_signature" && (
              <div>
                <h3 className="headline">
                  {this.props.i18n.t("NamespaceDelegationLogs:NamespaceDelegationLogs:QI confirm all staff members signed signature")}
                </h3>
                <h4 className="headline">
                  {this.props.i18n.t("NamespaceDelegationLogs:Study Personnel Signature and Delegation Log")}
                </h4>
                <h5 className="headline">
                  {this.props.i18n.t("NamespaceDelegationLogs:My signature confirms that the Delegation Log is fully completed and signed.")}
                </h5>
                <br />
              </div>
            )}
            {type === "qi_staff_changed_signature" && (
              <div>
                <h3 className="headline">{this.props.i18n.t("NamespaceDelegationLogs:QI confirm staff member changes")}</h3>
                <h5 className="headline">
                  {this.props.i18n.t("NamespaceDelegationLogs:Some staff members have been changed")}
                </h5>
                <h5 className="headline">
                  {this.props.i18n.t("NamespaceDelegationLogs:Please sign the changes to the roles and dates for these staff members:")}
                </h5>
                <br />
              </div>
            )}
            {type === "qi_end_of_study_signature" && (
              <div>
                <h3 className="headline">{this.props.i18n.t("NamespaceDelegationLogs:QI confirm End of Study signature")}</h3>
                <h4 className="headline">
                  {this.props.i18n.t("NamespaceDelegationLogs:Study Personnel Signature and Delegation Log")}
                </h4>
                <h5 className="headline">
                  {this.props.i18n.t("NamespaceDelegationLogs:To be signed and dated by the Qualified Investigator at the Study Closeout:")}
                </h5>
                <p>
                  {this.props.i18n.t("NamespaceDelegationLogs:This will serve as End of Tasks date for all staff with delegated tasks that continued until the Study Closeout.")}
                </p>
                <br />
              </div>
            )}
          </div>

          <div className={classes.stepWrapper}>
            <Badge
              count={`Step ${step}`}
              style={{ backgroundColor: "#2968AE" }}
            />
          </div>

          {step === 1 && (
            <div>
              <div className={classes.descriptionWrapper}>
                <div>Sponsor: {delegationLog.sponsor_name}</div>
                <div>
                  {this.props.i18n.t("NamespaceDelegationLogs:Qualified Investigator")}:{" "}
                  {get(delegationLog, "qualified_investigator_data.name")}
                </div>
                <div>
                  Protocol Number: {delegationLog.major_version}
                  {delegationLog.minor_version}
                </div>
                <div>
                  {this.props.i18n.t("NamespaceDelegationLogs:Site number & country")}: {get(site, "code")} -{" "}
                  {get(site, "name")}
                </div>
              </div>

              <div
                dangerouslySetInnerHTML={{ __html: delegationLog.description }}
                className={classes.description}
              />

              <div className={classes.tableWrapper}>
                <Table
                  columns={[
                    {
                      title: "",
                      dataIndex: "id",
                      key: "id",
                    },
                    {
                      title: this.props.i18n.t("NamespaceDelegationLogs:Printed Qualified Investigator Name"),
                      dataIndex: "qualified_investigator_name",
                      key: "qualified_investigator_name",
                    },
                    {
                      title: this.props.i18n.t("NamespaceDelegationLogs:Qualified investigator signature"),
                      dataIndex: "qualified_investigator_start_study_signature",
                      key: "qualified_investigator_start_study_signature",
                      render: (val) =>
                        val && <img src={val} alt="signature" height={60} />,
                    },
                    {
                      title: this.props.i18n.t("NamespaceDelegationLogs:Initials"),
                      dataIndex: "qualified_investigator_start_study_initials",
                      key: "qualified_investigator_start_study_initials",
                      render: (val) =>
                        val && <img src={val} alt="signed_at" height={60} />,
                    },
                    {
                      title: this.props.i18n.t("NamespaceDelegationLogs:Signed at"),
                      dataIndex: "qualified_investigator_start_study_signed_at",
                      key: "qualified_investigator_start_study_signed_at",
                      render: (val) => (
                        <div>
                          {val &&
                            moment
                              .utc(val)
                              .tz(this.props.userTimezone || "UTC")
                              .format("YYYY-MM-DD HH:mm")}
                          &nbsp;{val && (this.props.userShortTimezone || "UTC")}
                        </div>
                      ),
                    },
                  ]}
                  dataSource={[
                    {
                      id: 1,
                      qualified_investigator_name: get(
                        delegationLog,
                        "qualified_investigator_data.name"
                      ),
                      qualified_investigator_start_study_signature: get(
                        delegationLog,
                        "qualified_investigator_data.del_log_signatures.qi_start_of_delegation_signature"
                      ),
                      qualified_investigator_start_study_initials: get(
                        delegationLog,
                        "qualified_investigator_data.del_log_signatures.qi_start_of_delegation_initials"
                      ),
                      qualified_investigator_start_study_signed_at: get(
                        delegationLog,
                        "qualified_investigator_data.del_log_signatures.qi_start_of_delegation_signed_at"
                      ),
                    },
                  ]}
                  pagination={false}
                />
              </div>

              <br />
              <br />

              {get(delegationLog, "staff_members", null) && (
                <div className={classes.tableWrapper}>
                  <Table
                    columns={[
                      {
                        title: this.props.i18n.t("NamespaceDelegationLogs:Staff Name"),
                        dataIndex: "name",
                        key: "name",
                      },
                      {
                        title: this.props.i18n.t("NamespaceDelegationLogs:Staff signature"),
                        dataIndex: "signature",
                        key: "signature",
                        render: (val) =>
                          val && <img src={val} alt="signature" height={60} />,
                      },
                      {
                        title: this.props.i18n.t("NamespaceDelegationLogs:Staff Initials"),
                        dataIndex: "initials",
                        key: "initials",
                        render: (val) =>
                          val && <img src={val} alt="initials" height={60} />,
                      },
                      {
                        title: this.props.i18n.t("NamespaceDelegationLogs:Study role"),
                        dataIndex: "study_role",
                        key: "study_role",
                      },
                      {
                        title: this.props.i18n.t("NamespaceDelegationLogs:Delegated tasks"),
                        dataIndex: "delegated_study_tasks",
                        key: "delegated_study_tasks",
                      },
                      {
                        title: this.props.i18n.t("NamespaceDelegationLogs:Date of delegation"),
                        dataIndex: "start_of_tasks_dt",
                        key: "start_of_tasks_dt",
                        render: (val) => <div>{val}</div>,
                      },
                      {
                        title: this.props.i18n.t("NamespaceDelegationLogs:QI Initials"),
                        dataIndex: "qi_staff_initials",
                        key: "qi_staff_initials",
                        render: (val) =>
                          val && <img src={val} alt="initials" height={60} />,
                      },
                      {
                        title: this.props.i18n.t("NamespaceDelegationLogs:End of tasks"),
                        dataIndex: "end_of_tasks_dt",
                        key: "end_of_tasks_dt",
                        render: (val) => <div>{val}</div>,
                      },
                      {
                        title: this.props.i18n.t("NamespaceDelegationLogs:QI Initials"),
                        dataIndex: "qi_staff_end_of_tasks_initials",
                        key: "qi_staff_end_of_tasks_initials",
                        render: (val) =>
                          val && <img src={val} alt="initials" height={60} />,
                      },
                    ]}
                    dataSource={get(delegationLog, "staff_members", [])}
                    pagination={false}
                  />
                </div>
              )}

              <br />

              {delegationLog.note && <div>{delegationLog.note}</div>}
              {this.state.type !== "staff_signature" && (
                <div>
                  <h5 className="headline-default">{this.props.i18n.t("NamespaceDelegationLogs:Roles")}</h5>
                  <div className={classes.contentWrapper}>
                    {map(delegationLog.all_roles, ({ id, name }, i) => (
                      <div key={id}>
                        {i + 1}. {name}
                      </div>
                    ))}
                  </div>
                  <h5 className="headline-default">{this.props.i18n.t("NamespaceDelegationLogs:Tasks")}</h5>
                  <div className={classes.contentWrapper}>
                    {map(delegationLog.all_tasks, ({ id, name }, i) => (
                      <div key={id}>
                        {i + 1}. {name}
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {this.state.type == "staff_signature" && (
                <div>
                  <h5 className="headline-default">{this.props.i18n.t("NamespaceDelegationLogs:My Roles")}</h5>
                  <div className={classes.contentWrapper}>
                    {map(delegationLog.my_roles, ({ id, name }, i) => (
                      <div key={id}>
                        {i + 1}. {name}
                      </div>
                    ))}
                  </div>
                  <h5 className="headline-default">{this.props.i18n.t("NamespaceDelegationLogs:My Tasks")}</h5>
                  <div className={classes.contentWrapper}>
                    {map(delegationLog.my_tasks, ({ id, name }, i) => (
                      <div key={id}>
                        {i + 1}. {name}
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/*{delegationLog.can_sign && (*/}
              <Button
                type="primary"
                size="large"
                htmlType="button"
                className={classes.submitButton}
                onClick={() => {
                  this.setState({
                    step: 2,
                  });
                }}
              >
                {this.props.i18n.t("Next")}
              </Button>
            </div>
          )}

          {step === 2 && (
            <div>
              <br />
              <div className={classes.contentWrapper}>
                <Row gutter={12}>
                  <Col>
                    <Form.Item>
                      {getFieldDecorator("confirm", {
                        rules: [
                          {
                            required: true,
                            message: this.props.i18n.t("Required"),
                          },
                        ],
                        valuePropName: "checked",
                      })(
                        <Checkbox>
                          <span style={{ fontSize: "18px", fontWeight: 600 }}>
                            {this.props.i18n.t("Confirm")}
                          </span>
                        </Checkbox>
                      )}
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={12}>
                  <Col>
                    <Signature
                      label={this.props.i18n.t("NamespaceDelegationLogs:Signature")}
                      fieldName="signature"
                      form={this.props.form}
                      isRequired={true}
                    />
                  </Col>
                </Row>

                <Row gutter={12}>
                  <Col>
                    <Signature
                      label={this.props.i18n.t("NamespaceDelegationLogs:Initials")}
                      fieldName="initials"
                      form={this.props.form}
                      isRequired={true}
                    />
                  </Col>
                </Row>

                <Row gutter={12}>
                  <Col lg={6}>
                    <Form.Item label={this.props.i18n.t("Password")}>
                      {getFieldDecorator("password", {
                        rules: [{ required: true, message: this.props.i18n.t("Required") }],
                      })(<Input.Password />)}
                    </Form.Item>
                  </Col>
                </Row>
              </div>

              {requestResult.type && (
                <Alert
                  message={requestResult.message}
                  type={requestResult.type}
                  className={classes.submitResult}
                />
              )}

              <div className={classes.actionWrapper}>
                <Button
                  type="secondary"
                  size="large"
                  htmlType="button"
                  loading={isLoading}
                  className={classes.submitButton}
                  onClick={() => {
                    this.setState({
                      step: 1,
                    });
                  }}
                >
                  {this.props.i18n.t("Back")}
                </Button>
                &nbsp;&nbsp;
                {isEditable && (
                  <Button
                    type="primary"
                    size="large"
                    htmlType="submit"
                    loading={isLoading}
                    className={classes.submitButton}
                  >
                    {this.props.i18n.t("Save")}
                  </Button>
                )}
              </div>
            </div>
          )}
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userTimezone: getUserTimezone(state),
  userShortTimezone: getUserShortTimezone(state),
  delegationLogSignPermission: getDelegationLogSignPermission(state),
});

const mapDispatchToProps = { logout };

export default Form.create({ name: "DelegationLogSignForm" })(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withRouter(withNamespaces()(DelegationLogSignForm)))
);



// WEBPACK FOOTER //
// ./src/containers/DelegationLogs/DelegationLogSignForm.js